<script>
export default {
    name: "PrescriptionAdmnHistory",

    props: {
        showModal: Boolean,
        patient: {
            type: Object,
            required: true,
        },
        visit: {
            type: Object,
            required: true,
        },
        prescription: {
            type: Object,
            required: true,
        },
        prescriptionHistory: {
            type: Object,
            required: true,
            default: () => ({
                patientDrugIssueHistory: [],
                patientTreatmentSheetDetails: [],
                lastSessionDetails: [],
            }),
        },
    },

    computed: {

        totalIssued() {
            if(!this.prescriptionHistory.patientDrugIssueHistory.length) return 0;

            return this.prescriptionHistory.patientDrugIssueHistory.map(item => item.issued ? parseFloat(item.issued) : 0)
                .reduce((sum, qty) => sum+qty);
        },

        totalAdministered() {
            if(!this.prescriptionHistory.patientTreatmentSheetDetails.length) return 0;

            return this.prescriptionHistory.patientTreatmentSheetDetails.map(item => item.qty ? parseFloat(item.qty) : 0)
                .reduce((sum, qty) => sum+qty);
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-3/4 w-11/12">
      <template v-slot:title>
        <h5 class="font-medium text-sm">Prescription History</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full flex flex-wrap content-start gap-1 mb-1 h-32 overflow-auto">
            <div class="md:flex-1 print:w-full w-full hide--print">
                <img src="@/assets/user.png" class="w-24 my-4 mx-auto" alt="">
            </div>
            <div class="md:flex-1 print:w-full w-full border-2 border-green-400">
                <div class="w-full flex flex-wrap p-1 bg-green-400 text-white">
                  <div class="flex-1">
                    Patient Details
                  </div>
                  <div class="flex-1"></div>
                </div>
                <div class="w-full p-1">
                    <h5 class="font-medium text-sm">{{ patient.names }}</h5>
                    <h5 class="font-medium text-sm">
                      MRN: {{ patient.patienT_ID }} 
                      IP: {{ patient.ipfileno || `-` }} 
                      OP: {{ patient.opfileno || `-` }}</h5>
                    <h5 class="font-medium text-sm">
                        DOB: {{ patient.dob | dateFormat }} Age: {{ patient.age || `-` }}</h5>
                    <h5 class="font-medium text-sm">Gender: {{ patient.gender }}</h5>
                </div>
            </div>
            <div class="md:flex-1 print:w-full w-full border-2 border-blue-400">
                <div class="w-full p-1 bg-blue-400 text-white">
                    Payment Mode
                </div>
                <div class="w-full p-1">
                    <p class="text-xs">{{ visit.pMode }}</p>
                </div>
            </div>
            <div class="md:flex-1 print:w-full w-full border-2 border-indigo-400">
                <div class="w-full p-1 bg-indigo-400 text-white">
                    Visit Details
                </div>
                <div class="w-full p-1">
                    <h5 class="font-medium text-sm">
                        Type: {{ patient.iS_OUTPATIENT ? `Outpatient` : `Inpatient` }}</h5>
                    <h5 class="font-medium text-sm">
                        Visit: {{ visit.date| dateFormat }}</h5>
                    <h5 class="font-medium text-sm">DOA: 
                      {{ visit.admissionDate | dateFormat }} DOD: {{ visit.disschargeDate | dateFormat }}</h5>
                    <h5 class="font-medium text-sm">Days: 
                        {{ 
                            visit.disschargeDate 
                              ? 
                            $moment(visit.disschargeDate).diff($moment(visit.admissionDate), `day`) 
                              : 
                            `-` 
                        }}
                    </h5>
                </div>
            </div>
        </div>
        <div class="w-full overflow-auto mt-2">
            <table class="table">
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny text-center" colspan="5">Processed</th>
                    </tr>
                </thead>
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Date/Time</th>
                        <th class="p-tiny">Drug</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">User</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody class="bg-gray-100 text-xs">
                    <tr>
                        <td class="p-tiny">{{ prescription.processedDateTime | dateFormatDT }}</td>
                        <td class="p-tiny">{{ prescription.drug }}</td>
                        <td class="p-tiny">{{ prescription.totalDosage }}</td>
                        <td class="p-tiny">{{ prescription.processedBy }}</td>
                        <td></td>
                    </tr>
                </tbody>
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny text-center" colspan="5">Issue History</th>
                    </tr>
                </thead>
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Date/Time</th>
                        <th class="p-tiny">Drug</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">User</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody
                    class="text-sm bg-gray-100">
                    <tr v-for="(issueHistory, ix) in prescriptionHistory.patientDrugIssueHistory" 
                    :key="`__iss_${ix}`">
                        <td class="p-tiny">{{ issueHistory.date | dateFormat }}</td>
                        <td class="p-tiny">
                            <h5 class="text-xs my-px">Drug: {{ issueHistory.item }}</h5>
                            <h5 class="text-xs my-px">Prescription: {{ issueHistory.prescription }}</h5>
                        </td>
                        <td class="p-tiny">
                            <h5 class="text-xs">{{ issueHistory.issued }}</h5>
                            
                        </td>
                        <td class="p-tiny">
                            <h5 class="text-xs">{{ issueHistory.user_Name}}</h5>
                        </td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="4" class="p-tiny text-right">Total: {{ totalIssued }}</td>
                        <td class="p-tiny"></td>
                    </tr>
                </tbody>
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny text-center" colspan="5">Administration History</th>
                    </tr>
                </thead>
                <thead class="bg-blue-500 text-white text-sm">
                    <tr>
                        <th class="p-tiny">Date/Time</th>
                        <th class="p-tiny">Administered</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Notes</th>
                        <th class="p-tiny">User</th>
                    </tr>
                </thead>
                <tbody
                    class="text-sm bg-gray-100">
                    <tr 
                        v-for="(admnHistory, ix) in 
                            prescriptionHistory.patientTreatmentSheetDetails" 
                        :key="`__adm_${ix}`">
                        <td class="p-tiny">
                            {{ admnHistory.dateAdministered | dateFormat }} -
                            {{ admnHistory.administeredTime }}
                        </td>
                        <td class="p-tiny">
                            {{ admnHistory.administrationOption }}
                        </td>
                        <td class="p-tiny">
                            {{ admnHistory.qty }}
                        </td>
                        <td class="p-tiny w-40 break-words">
                            <span v-html="admnHistory.memo"></span>
                        </td>
                        <td class="p-tiny">
                            {{ admnHistory.userName || `-` }}
                        </td>
                    </tr>
                </tbody>
                <tfoot class="bg-gray-300">
                    <tr>
                        <th class="p-1 text-center">
                            <h5 class="text-sm">Total Processed</h5>
                            <h5 class="text-sm">{{ prescription.totalDosage }}</h5>
                        </th>
                        <th class="p-1 text-center">
                            <h5 class="text-sm">Total Issued</h5>
                            <h5 class="text-sm">{{ totalIssued }}</h5>
                        </th>
                        <th class="p-1 text-center">
                            <h5 class="text-sm">Total Administered</h5>
                            <h5 class="text-sm">{{ totalAdministered }}</h5>
                        </th>
                        <th class="p-1 text-center">
                            <h5 class="text-sm">Total On-trolley</h5>
                            <h5 class="text-sm">{{ totalIssued - totalAdministered }}</h5>
                        </th>
                        <th></th>
                    </tr>
                </tfoot>
            </table>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
            class="btn-danger btn-sm text-xs rounded" 
            @click.prevent="$emit(`closeModal`)">
                <i class="fa fa-times"></i> Close</button>
      </template>
    </tail-modal>
</template>